import React from 'react';
import './Pages.css';

const Privacy = () => {
  return React.createElement(
    'main',
    { className: 'page-content' },
    React.createElement(
      'div',
      { className: 'container' },
      React.createElement('h1', null, 'Privacy Policy'),
      React.createElement('p', null, 'Your privacy is important to us. This policy explains how we collect, use, and protect your personal information...'),
      React.createElement('h3', null, 'Information We Collect'),
      React.createElement('p', null, 'We collect information you provide directly, such as your name, email address, and professional details...'),
      React.createElement('h3', null, 'How We Use Information'),
      React.createElement('p', null, 'We use your information to provide and improve our services, communicate with you, and personalize your experience...'),
      React.createElement('h3', null, 'Data Security'),
      React.createElement('p', null, 'We implement appropriate security measures to protect your personal information...')
    )
  );
};

export default Privacy;